import React, { useState, useEffect } from 'react';

import { Fragment } from 'react';
import { Menu, Transition } from '@headlessui/react';

import Select from 'react-tailwindcss-select';

import { Link } from 'react-router-dom';
import OutsideClickHandler from 'react-outside-click-handler';
import { useDispatch, useSelector } from 'react-redux';
import { getManagerList } from '../../../redux/actions/user/getManagerList';
import { useForm } from 'react-hook-form';
import Input from '../../Input/Input';
import { updateManagerVacancy } from '../../../redux/actions/dashborad/updateManagerVacancy';
import Loading from '../../Loading/Loading';
import { resetUpdateManagerVacancy } from '../../../redux/slices/dashboard.slice';
import { toast } from 'react-toastify';
import VacancyCellManager from './VacancyCellManager';
import VacancyStatus from '../../VacancyStatus/VacancyStatus';

export default function VacancyItem({ handleCheckChange, ...props }) {
  const { is_verified, key, num, date, state, jobName, jobPosterName, regState, type, payState, manager, vacState, checked, id, total_applications } = props;
  function classNames(...classes) {
    return classes.filter(Boolean).join(' ');
  }

  return (
    <tr key={key}>
      <td className="p-2">
        <div className="flex items-center h-5">
          <input
            type="checkbox"
            onChange={(e) => {
              handleCheckChange({ ...props, checked: e.target.checked });
            }}
            checked={checked}
            className="w-4 h-4 border-gray-200 rounded accent-button"
          />
        </div>
      </td>
      <td className="p-2 hidden md:table-cell">
        <p className="whitespace-nowrap">
          {num} - {date}
        </p>
      </td>
      <td className="flex flex-col w-fit px-2 py-1">
        <p className="block md:hidden whitespace-nowrap">
          {num} - {date}
        </p>
        {regState === 1 ? (
          <Link to={`/activation/${num}`}>
            <p className="flex items-center whitespace-nowrap">
              {jobName}
              {!regState ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="flex icon icon-tabler icon-tabler-alert-triangle self-center ml-1 align-middle text-yellow-600"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  strokeWidth="2"
                  stroke="currentColor"
                  fill="none"
                  strokeLinecap="round"
                  strokeLinejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                  <path d="M12 9v2m0 4v.01"></path>
                  <path d="M5 19h14a2 2 0 0 0 1.84 -2.75l-7.1 -12.25a2 2 0 0 0 -3.5 0l-7.1 12.25a2 2 0 0 0 1.75 2.75"></path>
                </svg>
              ) : (
                ''
              )}
            </p>
            <span className="text-gray-400 whitespace-nowrap">{jobPosterName}</span>
          </Link>
        ) : (
          <Link to={`/activationManager`}>
            <p className="flex whitespace-nowrap">
              {jobName}
              <VacancyStatus />
              {is_verified ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="flex icon icon-tabler icon-tabler-alert-triangle self-center ml-1 align-middle text-yellow-600"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  strokeWidth="2"
                  stroke="currentColor"
                  fill="none"
                  strokeLinecap="round"
                  strokeLinejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                  <path d="M12 9v2m0 4v.01"></path>
                  <path d="M5 19h14a2 2 0 0 0 1.84 -2.75l-7.1 -12.25a2 2 0 0 0 -3.5 0l-7.1 12.25a2 2 0 0 0 1.75 2.75"></path>
                </svg>
              ) : (
                ''
              )}
            </p>
            <span className="flex text-gray-400 ">{jobPosterName}</span>
          </Link>
        )}
      </td>
      <td className="p-2">{type}</td>
      <VacancyCellManager num={num} manager={manager} />
      <td className="p-2">
        <Link to={`/applications/${num}`}>
          <button type="button" className="text-center border rounded py-2 px-2  text-button border-button border-1 w-full md:w-auto hover:text-white bg-white hover:bg-button transition ease-in-out duration-300 whitespace-nowrap">
            Отклики ({total_applications ?? 0})
          </button>
        </Link>
      </td>
    </tr>
  );
}
